/* app/js/src/components/channel/channel.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  height: 1px;
}
/*# sourceMappingURL=channel.component.css.map */
